// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1e5_C","col":"styles_col__2OOMC"};